import React from 'react';
import { siteContent } from '../data/mock';

export const Header = () => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-stone-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        <div className="text-lg font-semibold text-stone-800 tracking-tight">
          {siteContent.brand.name}
        </div>
        <nav className="hidden sm:flex items-center gap-6">
          <button
            onClick={() => scrollTo('what-we-do')}
            className="text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors"
          >
            What we do
          </button>
          <button
            onClick={() => scrollTo('pricing')}
            className="text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors"
          >
            Pricing
          </button>
          <button
            onClick={() => scrollTo('how-it-works')}
            className="text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors"
          >
            How it works
          </button>
          <button
            onClick={() => scrollTo('contact')}
            className="text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors"
          >
            Get in touch
          </button>
        </nav>
        <button
          onClick={() => scrollTo('contact')}
          className="sm:hidden text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors"
        >
          Get in touch
        </button>
      </div>
    </header>
  );
};
